// @ts-nocheck
import React from 'react';

import * as styles from './styles';
import {
  Backdrop,
  Drawer as MuiDrawer,
  type DrawerProps as MuiDrawerProps,
  withStyles,
} from '@material-ui/core';

import { CloseButton } from '../Button';
import { Divider } from '../Divider';
import { backgrounds, colors } from '../styles';
import { Heading1 } from '../typography';

const StyledDrawer = withStyles(() => ({
  paperAnchorRight: {
    width: (props: DrawerProps) => props.customWidth || '440px',
    border: `1px solid ${colors.gray.light}`,
    boxSizing: 'border-box',
    boxShadow: 'none',
  },
}))((props: DrawerProps) => {
  const { title, customWidth, ...muiDrawerProps } = props;

  return <MuiDrawer {...muiDrawerProps} />;
});

const StyledBackdrop = withStyles({
  root: {
    backgroundColor: backgrounds.modal.modalScrimBackground,
  },
})(Backdrop);

type RestrictMuiDrawerProps = Omit<MuiDrawerProps, 'title'>;

export interface DrawerProps extends RestrictMuiDrawerProps {
  title?: string | React.ReactNode;
  header?: React.ReactNode;
  stickyHeader?: boolean;
  body?: React.ReactNode;
  titleDivider?: boolean;
  customWidth?: number | string;
  closeOnClickOutside?: boolean;
  headerClassName?: string;
  bodyClassName?: string;
  titleClassName?: string;
  onClose?: () => void;
  onCloseButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  customCloseDrawerButton?: React.ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({
  title: Title,
  header,
  stickyHeader,
  body,
  onClose,
  onCloseButtonClick,
  titleDivider = true,
  customWidth,
  closeOnClickOutside,
  headerClassName = '',
  bodyClassName = '',
  titleClassName = '',
  customCloseDrawerButton,
  ...otherProps
}) => (
  <StyledDrawer
    closeOnClickOutside={(closeOnClickOutside && onClose) || undefined}
    BackdropComponent={StyledBackdrop}
    anchor='right'
    customWidth={customWidth}
    {...otherProps}
  >
    <div className={styles.headerBackground(stickyHeader)}>
      <div className={`${styles.header} ${headerClassName}`}>
        <div className={styles.headerTitleDivider}>
          <div className={`${styles.headerTitle} ${titleClassName}`}>
            {React.isValidElement(Title) ? Title : <Heading1>{Title}</Heading1>}
            {(customCloseDrawerButton && customCloseDrawerButton) || (
              <CloseButton onClick={onCloseButtonClick || onClose} />
            )}
          </div>
          {titleDivider && <Divider />}
        </div>
        {header}
      </div>
    </div>
    <div className={`${styles.body} ${bodyClassName}`}>{body}</div>
  </StyledDrawer>
);
